import FilterWrapper from './FilterWrapper'

export default FilterWrapper
